import React, { useEffect, useState } from 'react';
import styled from 'styled-components/macro';
import Swiper from 'swiper';
import useWindowSize from '../../../hooks/utils/useWindowSize';

interface Props {
  swiper: Swiper | undefined;
  images: any;
}

export const CarouselPagination: React.FC<Props> = ({ swiper, images }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const { width } = useWindowSize();

  useEffect(() => {
    setActiveIndex(0);
  }, [width]);

  swiper?.on('slideChange', () => setActiveIndex(swiper.realIndex));

  return (
    <ContainerMobileOnly>
      {images?.map((_: any, index: number) => {
        return (
          <Element
            key={`image-pagination-${index}`}
            active={index === activeIndex}
          />
        );
      })}
    </ContainerMobileOnly>
  );
};

const ContainerMobileOnly = styled.div`
  --width: 20px;
  --height: 2px;
  display: flex;
  width: fit-content;
  z-index: 2;
  margin: 0 auto;
  gap: 0.3125rem;
`;

const Element = styled.div<{ active: boolean }>`
  background: ${({ theme, active }) =>
    active ? theme.colors.red : theme.colors.white};

  width: var(--width);
  height: var(--height);
  cursor: pointer;
`;
